import { useContext } from 'react';

import { ViewFiltersContext } from '../providers/view-filters';

export { defaultViewFilters } from '../providers/view-filters';

export function useViewFilters() {
  return useContext(ViewFiltersContext);
}
